/**
 * Typographic Scale Constants
 * 
 * DESIGN RATIONALE:
 * - Follows the "No Magic Values" mandate by externalizing all multipliers.
 * - Multipliers are derived from the Major Second (1.125) and Perfect Fourth (1.333) scales.
 * - Anchor points are Sm, Base, and Lg (configured via Admin Panel).
 */

export const TYPOGRAPHIC_SCALE = {
    /** smAnchor = configuration.typography.fontSize.sm */
    XS_FACTOR: 0.85,    // ~12px if sm is 14px

    /** baseAnchor = configuration.typography.fontSize.base */
    BASE_FACTOR: 1.0,   // Standard scale (16px)

    /** lgAnchor = configuration.typography.fontSize.lg (Heading Anchor) */
    XL_FACTOR: 0.83,    // ~20px if lg is 24px (Anchor point interpolation)
    '2XL_FACTOR': 1.0,  // The lgAnchor itself (24px)
    '3XL_FACTOR': 1.25, // ~30px if lg is 24px
    '4XL_FACTOR': 1.5,  // ~36px if lg is 24px
    '5XL_FACTOR': 2.0,  // ~48px if lg is 24px
} as const;

export const TYPOGRAPHY_DEFAULTS = {
    BASE_PX: 16,
    SM_PX: 14,
    LG_PX: 24,
    LINE_HEIGHT: '1.5',
    TRACKING_NORMAL: '0em',
    TRACKING_TIGHT: '-0.025em',
    TRACKING_WIDE: '0.025em',
} as const;
